import React from "react";
import ProductFormInput from "../../account/productForm/ProductFormInput";

export const Step1 = () => {

	return (
		<ProductFormInput isLocalSave={true}/>
	)
}
export default Step1